<template>
    <div>
        <Header />
        <div class="hero-bg">
            <div class="container-fluid hero-text">
                <div class="row">
                    <div class="col-md-4">
                        <h5>Contact us</h5>
                        <p>Need help? We are here to help with all your property management support needs. </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container contact-section">
            <div class="row">
                <div class="col-md-6 inquire">
                    <div class="inquiries-header">
                        <h5>For More Inquiries</h5>
                        <p>Reach us directly through any of our contact channel below. </p>
                    </div>
                    <div>
                        <div class="inquiry-contacts">
                            <span>
                                <a href="tel:2348061796909">
                                    <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" fill="white"/>
                                        <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <g clip-path="url(#clip0_9420_221888)">
                                        <path d="M24.5475 15C25.5242 15.1906 26.4219 15.6683 27.1256 16.3719C27.8292 17.0756 28.3069 17.9733 28.4975 18.95M24.5475 11C26.5768 11.2254 28.4691 12.1342 29.9137 13.577C31.3584 15.0198 32.2695 16.911 32.4975 18.94M31.4975 26.92V29.92C31.4986 30.1985 31.4416 30.4742 31.33 30.7293C31.2184 30.9845 31.0548 31.2136 30.8496 31.4019C30.6443 31.5901 30.4021 31.7335 30.1382 31.8227C29.8744 31.9119 29.5949 31.9451 29.3175 31.92C26.2403 31.5856 23.2845 30.5341 20.6875 28.85C18.2713 27.3147 16.2228 25.2662 14.6875 22.85C12.9975 20.2412 11.9457 17.271 11.6175 14.18C11.5925 13.9035 11.6254 13.6248 11.714 13.3616C11.8026 13.0985 11.9451 12.8567 12.1323 12.6516C12.3195 12.4466 12.5473 12.2827 12.8013 12.1705C13.0553 12.0583 13.3298 12.0003 13.6075 12H16.6075C17.0928 11.9952 17.5633 12.1671 17.9313 12.4835C18.2992 12.8 18.5396 13.2394 18.6075 13.72C18.7341 14.6801 18.9689 15.6227 19.3075 16.53C19.442 16.8879 19.4712 17.2769 19.3914 17.6509C19.3116 18.0248 19.1264 18.3681 18.8575 18.64L17.5875 19.91C19.011 22.4135 21.0839 24.4864 23.5875 25.91L24.8575 24.64C25.1294 24.3711 25.4726 24.1859 25.8466 24.1061C26.2206 24.0263 26.6096 24.0555 26.9675 24.19C27.8748 24.5286 28.8174 24.7634 29.7775 24.89C30.2633 24.9585 30.7069 25.2032 31.024 25.5775C31.3412 25.9518 31.5097 26.4296 31.4975 26.92Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221888">
                                        <rect width="24" height="24" fill="white" transform="translate(9.5 10)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                            </span>
                            <div>
                                <h6>Call us</h6>
                                <p>(+234) 806-1796-909</p>
                            </div>
                        </div>

                        <div class="inquiry-contacts">
                            <span>
                                <a href="mailto:hello@myshelta.com">
                                    <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" fill="white"/>
                                        <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M29.5 14H13.5C12.4 14 11.5 14.9 11.5 16V28C11.5 29.1 12.4 30 13.5 30H29.5C30.6 30 31.5 29.1 31.5 28V16C31.5 14.9 30.6 14 29.5 14Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M31.5 16L21.5 23L11.5 16" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </a>

                            </span>
                            <div>
                                <h6>Email Us On</h6>
                                <p>hello@myshelta.com</p>
                            </div>
                        </div>
                        <div class="inquiry-contacts">
                            <span>
                                <a href="https://api.whatsapp.com/send?phone=2348061796909">
                                    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" width="42" height="42" rx="21" fill="white"/>
                                        <path d="M31.4975 28.9201V25.9201C31.5097 25.4297 31.3412 24.9519 31.024 24.5776C30.7069 24.2033 30.2633 23.9586 29.7775 23.8901C28.8174 23.7635 27.8748 23.5286 26.9675 23.1901C26.6096 23.0556 26.2206 23.0264 25.8466 23.1062C25.4726 23.1859 25.1294 23.3712 24.8575 23.6401L23.5875 24.9101C21.0839 23.4865 19.011 21.4136 17.5875 18.9101L18.8575 17.6401C19.1264 17.3682 19.3116 17.0249 19.3914 16.651C19.4712 16.277 19.442 15.888 19.3075 15.5301C18.9689 14.6228 18.7341 13.6802 18.6075 12.7201C18.5396 12.2395 18.2992 11.8001 17.9313 11.4836C17.5633 11.1672 17.0928 10.9953 16.6075 11.0001H13.6075C13.3298 11.0004 13.0553 11.0584 12.8013 11.1706C12.5473 11.2828 12.3195 11.4466 12.1323 11.6517C11.9451 11.8568 11.8026 12.0986 11.714 12.3617C11.6254 12.6249 11.5925 12.9036 11.6175 13.1801C11.9457 16.2711 12.9975 19.2413 14.6875 21.8501C16.2228 24.2663 18.2713 26.3148 20.6875 27.8501C23.2845 29.5342 26.2403 30.5857 29.3175 30.9201C29.5949 30.9452 29.8744 30.912 30.1382 30.8228C30.4021 30.7336 30.6443 30.5902 30.8496 30.402C31.0548 30.2137 31.2184 29.9846 31.33 29.7294C31.4416 29.4743 31.4986 29.1986 31.4975 28.9201Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </a>
                            </span>
                            <div>
                                <h6>Whatsapp</h6>
                                <p>08061796909</p>
                            </div>
                        </div>
                        <div class="inquiry-contacts">
                            <span>
                                <svg width="43" height="44" viewBox="0 0 43 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" fill="white"/>
                                    <rect x="0.25" y="0.75" width="42.5" height="42.5" rx="21.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                    <path d="M21.5 33C21.5 33 30.5 27 30.5 20C30.5 17.6131 29.5518 15.3239 27.864 13.636C26.1761 11.9482 23.8869 11 21.5 11C19.1131 11 16.8239 11.9482 15.136 13.636C13.4482 15.3239 12.5 17.6131 12.5 20C12.5 27 21.5 33 21.5 33Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.5 23C23.1569 23 24.5 21.6569 24.5 20C24.5 18.3431 23.1569 17 21.5 17C19.8431 17 18.5 18.3431 18.5 20C18.5 21.6569 19.8431 23 21.5 23Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                            </span>
                            <div>
                                <h6>Head Office</h6>
                                <p> 3. Portharcourt Crescent,  Area 11, Abuja, Federal Capital Territory.</p>
                            </div>
                        </div>
                    </div>

                    <div class="socials-section">
                        <div class="inquiries-header">
                            <h5 class="mb-4">Follow us on</h5>
                            
                            <div>
                                <span>
                                    <a href="http://www.facebook.com/myshelta">
                                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="42" height="42" rx="21" fill="#194BFF"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6818 19.8333C14.7041 19.8333 14.5 20.0252 14.5 20.9444V22.6111C14.5 23.5304 14.7041 23.7222 15.6818 23.7222H18.0455V30.3889C18.0455 31.3081 18.2495 31.5 19.2273 31.5H21.5909C22.5687 31.5 22.7727 31.3081 22.7727 30.3889V23.7222H25.4267C26.1683 23.7222 26.3594 23.5867 26.5631 22.9164L27.0696 21.2497C27.4185 20.1014 27.2035 19.8333 25.9332 19.8333H22.7727V17.0556C22.7727 16.4419 23.3018 15.9444 23.9545 15.9444H27.3182C28.2959 15.9444 28.5 15.7526 28.5 14.8333V12.6111C28.5 11.6918 28.2959 11.5 27.3182 11.5H23.9545C20.691 11.5 18.0455 13.9873 18.0455 17.0556V19.8333H15.6818Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                                        </svg>
                                    </a>
                                </span>
                                <span>
                                    <a href="http://www.twitter.com/myshelta">
                                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="42" height="42" rx="21" fill="#0033EA"/>
                                            <path d="M11.5 31.5L19.8871 23.1129M19.8871 23.1129L11.5 11.5H17.0556L23.1129 19.8871M19.8871 23.1129L25.9444 31.5H31.5L23.1129 19.8871M31.5 11.5L23.1129 19.8871" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </a>
                                </span>
                                <span>
                                    <a href="http://www.instagram.com/myshelta">
                                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="42" height="42" rx="21" fill="#0033EA"/>
                                            <path d="M12 21.5C12 17.0217 12 14.7825 13.3912 13.3912C14.7825 12 17.0217 12 21.5 12C25.9783 12 28.2175 12 29.6088 13.3912C31 14.7825 31 17.0217 31 21.5C31 25.9783 31 28.2175 29.6088 29.6088C28.2175 31 25.9783 31 21.5 31C17.0217 31 14.7825 31 13.3912 29.6088C12 28.2175 12 25.9783 12 21.5Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                                            <path d="M26 21.5C26 23.9853 23.9853 26 21.5 26C19.0147 26 17 23.9853 17 21.5C17 19.0147 19.0147 17 21.5 17C23.9853 17 26 19.0147 26 21.5Z" stroke="white" stroke-width="1.5"/>
                                            <path d="M27.009 16H27" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </a>
                                </span>
                                <span>
                                    <a href="http://www.linkedin.com/company/myshelta">
                                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="42" height="42" rx="21" fill="#0033EA"/>
                                            <path d="M15 19H14.5C13.5572 19 13.0858 19 12.7929 19.2929C12.5 19.5858 12.5 20.0572 12.5 21V29.5C12.5 30.4428 12.5 30.9142 12.7929 31.2071C13.0858 31.5 13.5572 31.5 14.5 31.5H15C15.9428 31.5 16.4142 31.5 16.7071 31.2071C17 30.9142 17 30.4428 17 29.5V21C17 20.0572 17 19.5858 16.7071 19.2929C16.4142 19 15.9428 19 15 19Z" stroke="white" stroke-width="1.5"/>
                                            <path d="M17 13.75C17 14.9926 15.9926 16 14.75 16C13.5074 16 12.5 14.9926 12.5 13.75C12.5 12.5074 13.5074 11.5 14.75 11.5C15.9926 11.5 17 12.5074 17 13.75Z" stroke="white" stroke-width="1.5"/>
                                            <path d="M22.826 19H22C21.0572 19 20.5858 19 20.2929 19.2929C20 19.5858 20 20.0572 20 21V29.5C20 30.4428 20 30.9142 20.2929 31.2071C20.5858 31.5 21.0572 31.5 22 31.5H22.5C23.4428 31.5 23.9142 31.5 24.2071 31.2071C24.5 30.9142 24.5 30.4428 24.5 29.5L24.5001 26.0001C24.5001 24.3433 25.0281 23.0001 26.5879 23.0001C27.3677 23.0001 28 23.6717 28 24.5001V29.0001C28 29.9429 28 30.4143 28.2929 30.7072C28.5857 31.0001 29.0572 31.0001 30 31.0001H30.4987C31.4413 31.0001 31.9126 31.0001 32.2055 30.7073C32.4984 30.4145 32.4985 29.9432 32.4987 29.0006L32.5001 23.5002C32.5001 21.015 30.1364 19.0002 27.7968 19.0002C26.4649 19.0002 25.2767 19.6531 24.5001 20.674C24.5 20.0439 24.5 19.7289 24.3632 19.495C24.2765 19.3469 24.1531 19.2235 24.005 19.1369C23.7711 19 23.4561 19 22.826 19Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                                        </svg>
                                    </a>

                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="contact-input">
                        <h4>Send a message</h4>
                        <div class="row contact-form">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="fname">First name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="fname"
                                        placeholder="First name"
                                        v-model="firstname"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="lname">Last name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="lname"
                                        placeholder="Last name"
                                        v-model="lastname"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">Phone number</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="phone"
                                        placeholder="Phone number"
                                        v-model="phone"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        id="email"
                                        placeholder="Email"
                                        v-model="email"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="subject">Subject</label>
                            <select name="" id="subject" class="form-control" v-model="subject">
                                <option value="" selected disabled>Select</option>
                                <option value="inquiry">Inquiry</option>
                                <option value="complaint">Complaint</option>
                                <option value="assistant">Assistant</option>
                            </select>
                        </div>
                        <div class="">
                            <div class="form-group">
                                <label for="message">Message</label>
                                <textarea name="message" class="form-control text-area" id="message" placeholder="Enter Message" v-model="message"></textarea>
                            </div>
                        </div>

                        <div class="form-group">
                            <button :disabled="loader" class="btn sheltaBtn w-100 mt-3" style="height: 50px;" @click="feedback()">
                                {{ loader ? 'Sending message...' : 'Send message' }}
                                <i
                                    class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                    v-if="loader"
                                    >
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="office-location-holder">
            <div class="container">
                <h5 class="location-text">Our Office Locations</h5>

                <div class="row">
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Head Office</h4>
                            <h6>3. Portharcourt Crescent, Area 11, Abuja, Federal Capital Territory.</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 806-1796-909</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Port Harcourt</h4>
                            <h6>97 Psychiatric Road, adjacent abundant life, Port Harcourt</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 905-7003-942</small>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Lagos</h4>
                            <h6>Suite 5, 2nd Floor, Front Wing, Oshopay Plaza, 17/19 Allen Avenue, Ikeja, Lagos.</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 808-6915-057</small>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Delta</h4>
                            <h6>43 old Anwai Rd besides Alpha Hydrocarbon Filling Station, Asaba Delta state</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 806-9336-043</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Ogun</h4>
                            <h6>22 Victory Close Off Makogi Road Behind MFM Prayer City Magboro Ogun State.</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 802-3938-139</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Cross River</h4>
                            <h6>36. POWA Complex, Along IBB Way, opposite Calabar International airport, Cross River State.</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 707-7444-445</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Lagos</h4>
                            <h6>19. Muftau Shobola Street, Off Haruna Street, Ifako-Ijaiye, Ogba Lagos</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 806-2491-764</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Kaduna</h4>
                            <h6>2, Kwara street, by Freedom Motors off yakowa Expressway, karji, kaduna</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 703-5585-515</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="office-location">
                            <div>
                                <span>
                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" fill="white"/>
                                        <rect x="0.75" y="0.75" width="32.5" height="32.5" rx="16.25" stroke="#EBEBEB" stroke-width="0.5"/>
                                        <path d="M17 28C17 28 26 22 26 15C26 12.6131 25.0518 10.3239 23.364 8.63604C21.6761 6.94821 19.3869 6 17 6C14.6131 6 12.3239 6.94821 10.636 8.63604C8.94821 10.3239 8 12.6131 8 15C8 22 17 28 17 28Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M17 18C18.6569 18 20 16.6569 20 15C20 13.3431 18.6569 12 17 12C15.3431 12 14 13.3431 14 15C14 16.6569 15.3431 18 17 18Z" stroke="#0033EA" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <h4>Port Harcourt</h4>
                            <h6>13 Total Gospel Avenue ( LK ANGA), Off Peter Odili Road, Port Harcourt</h6>
                            <div>
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_9420_221960)">
                                        <path d="M10.0317 3.33317C10.6828 3.46021 11.2813 3.77868 11.7504 4.24779C12.2195 4.71691 12.538 5.31535 12.665 5.9665M10.0317 0.666504C11.3845 0.816795 12.6461 1.42262 13.6092 2.38451C14.5723 3.3464 15.1797 4.60718 15.3317 5.95984M14.665 11.2798V13.2798C14.6657 13.4655 14.6277 13.6493 14.5533 13.8194C14.479 13.9895 14.3699 14.1422 14.233 14.2677C14.0962 14.3933 13.9347 14.4888 13.7588 14.5483C13.5829 14.6078 13.3966 14.6299 13.2117 14.6132C11.1602 14.3903 9.18966 13.6893 7.45833 12.5665C5.84755 11.5429 4.48189 10.1773 3.45833 8.5665C2.33165 6.82731 1.63049 4.84717 1.41166 2.7865C1.395 2.60215 1.41691 2.41634 1.47599 2.24092C1.53508 2.0655 1.63004 1.9043 1.75484 1.76758C1.87964 1.63087 2.03153 1.52164 2.20086 1.44685C2.37018 1.37206 2.55322 1.33334 2.73833 1.33317H4.73833C5.06187 1.32999 5.37552 1.44456 5.62084 1.65553C5.86615 1.8665 6.02638 2.15947 6.07166 2.47984C6.15608 3.11988 6.31263 3.74832 6.53833 4.35317C6.62802 4.59179 6.64744 4.85111 6.59427 5.10042C6.5411 5.34973 6.41757 5.57858 6.23833 5.75984L5.39166 6.6065C6.3407 8.27553 7.72263 9.65747 9.39166 10.6065L10.2383 9.75984C10.4196 9.5806 10.6484 9.45707 10.8977 9.4039C11.1471 9.35073 11.4064 9.37014 11.645 9.45984C12.2498 9.68554 12.8783 9.84209 13.5183 9.9265C13.8422 9.97219 14.1379 10.1353 14.3494 10.3848C14.5608 10.6344 14.6731 10.9529 14.665 11.2798Z" stroke="#7593FF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_9420_221960">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </span>
                                <small>(+234) 8063-434-703</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.253575033538!2d7.5027265!3d9.0406183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b9353d2ddd7%3A0xed41cee4482dc62e!2s3%20Port%20Harcourt%20Cres%2C%20Garki%2C%20Abuja%20900103%2C%20Federal%20Capital%20Territory!5e0!3m2!1sen!2sng!4v1757676716782!5m2!1sen!2sng" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <FooterMain />
    </div>
</template>

<script>
import '@/assets/styles/custom.scss';
import FooterMain from "../views/FooterMain";
import Header from "../views/Header";
import { Service } from "../store/service";
const Api = new Service();

export default {
  name: "ContactUs",
  components: {
    Header,
    FooterMain
  },
  data() {
    return {
      loader: false,
      errors: [],
      subject: "",
      firstname: "",
      lastname: "",
      email: "",
      message: "",
      phone: "",
      subject: ""
    };
  },
  mounted() {
    // this.fetchProperties();
  },
  methods: {
    feedback() {
      this.loader = true;
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.firstname === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "First name is required!");
      }
      if (this.lastname === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Last name is required!");
      }
      if (this.email === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Email is required!");
      }
      if (!regex.test(this.email)) {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Invalid Email Address!");
      } 
      if (this.phone === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Phone number is required!");
      }
      if (this.subject === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Select subject");
      }
      if (this.message === "") {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Enter message");
      } else {
        Api.postRequest(`processcontactus`, {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          subject: this.subject,
          message: this.message,
          phone: this.phone
        })
          .then(res => {
                this.loader = false;
                this.$store.commit("setApiSuccess", "Success");
              (this.firstname = ""),
              (this.lastname = ""),
              (this.email = ""),
              (this.message = ""),
              (this.phone = ""),
              (this.subject = ""),
              console.log("Feedback sent", res);
            })
          .catch(err => {
            this.loader = false;
            return this.$store.commit("setApiFailed", res.data.error);
            console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
    .hero-bg {
        background-image: url(../assets/images/contactus-bg.svg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 565px;
        max-height: 565px; 
        min-height: 190px;
        margin-top: 7rem;
    }

    .hero-text {
        text-align: left;
        padding-top: 15rem;
        padding-left: 10rem;
        h5 {
            font-family: Lato;
            font-weight: 700;
            font-size: 50px;
            line-height: 50px;
            color: #ffffff;
        }
        p {
            font-family: Lato;
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
            color: #ffffff;
        }
    }

    .contact-section {
        background: #FAFAFA;
        padding-top: 50px;
    }
    .inquiries-header {
        text-align: left;
        h5 {
            font-family: Lato;
            font-weight: 600;
            font-size: 24px;
            line-height: 100%;
            color: #2B3352;
        }
        p {
            font-family: Lato;
            font-weight: 400;
            font-size: 16px;
            line-height: 100%;
            color: #555C74;
        }
    }

    .inquiry-contacts {
        display: flex;
        gap: 10px;
        margin-top: 35px;
        h6 {
            font-family: Lato;
            font-weight: 700;
            font-size: 16px;
            // line-height: 32px;
            color: #2B3352;
            text-align: left;
        }
        p {
            font-family: Lato;
            font-weight: 400;
            font-size: 15px;
            line-height: 25px;
            color: #555C74;
            text-align: left;
        }
    }
    .contact-form {
        margin-top: 30px;
        text-align: left;
    }
    .contact-input {
        padding: 32px;
        box-shadow: 0px 8px 24px 0px #0000000D;
        background: #ffffff;
        border-radius: 4px;
        margin-bottom: 20px;
        h4 {
            text-align: left;
            font-family: Lato;
            font-weight: 600;   
            font-size: 36px;
            line-height: 32px;
            color: #2B3352;
        }
    }   
    label {
        display: flex;
    }

    textarea {
        min-height: 100px !important;
    }


    .location-text {
        font-family: Lato;
        font-weight: 600;
        font-size: 36px;
        line-height: 35px;
        color: #2B3352;
        text-align: center;
        margin-top: 40px;
        margin-bottom: 50px;
    }
    .office-location {
        text-align: left;
        padding: 24px;
        border-radius: 12px;
        background: #FAFAFA;
        margin-bottom: 40px;
        h4 {
            font-family: Lato;
            font-weight: 700;
            font-size: 24px;
            line-height: 35px;
            color: #2B3352;
            margin-top: 15px;
        }
        h6 {
            font-family: Lato;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            color: #555C74;

        }
        small {
            font-family: Lato;
            font-family: Lato;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            color: #555C74;
            margin-left: 10px;
        }
    }
    .socials-section {
        margin-top: 50px;
        margin-bottom: 40px;
        span:not(:first-child) {
            margin-left: 15px;
        }
    }

    .inquire {
        padding: 3rem;
    }
    @media only screen and (max-width: 599px) {
        .hero-bg {
            max-height: 190px; 
        }
        .hero-text {
            text-align: left;
            padding-top: 2rem;
            padding-left: 1rem;
            h5 {
                font-size: 30px;
            }
            p {
                font-size: 14px;
            }
        }
        .inquire {
            padding: 3rem 2rem;
        }
        .contact-input {
            h4 {
                font-size: 25px;
            }
        }
        .location-text {
            font-size: 25px;
        }
    }
</style>